import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    author: "E. U.",
    source: "Google",
    time: "vor einem Jahr",
    text: "Einer der besten Gyros überhaupt! Die Portion ist groß und das Preis-Leistungs-Verhältnis stimmt. Ich habe telefonisch bestellt — nach 10 Minuten war alles fertig zur Abholung.",
  },
  {
    author: "Menulist-Gast",
    source: "Menulist",
    time: "vor 2 Jahren",
    text: "Tolles Essen, faires Preis-Leistungs-Verhältnis, freundliches Personal! Es wird auch Englisch gesprochen. Ich komme auf jeden Fall wieder.",
  },
  {
    author: "Michael Vogel",
    source: "Google",
    time: "vor 7 Jahren",
    text: "Einer von zwei sehr guten griechischen Imbissen in der Siegener Innenstadt. Gyros komplett plus ein Getränk für 9,50 €. Die Portion ist ordentlich, die Öffnungszeiten sind besser als beim anderen Restaurant.",
  },
];

const Stars = ({ className }) => (
  <div className={`flex gap-1 ${className || ""}`}>
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={14} strokeWidth={1.5} className="fill-[#C9A227] text-[#C9A227]" />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="bewertungen" data-testid="reviews-section" className="relative z-10 bg-[#F0EFEA]/70 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
        className="mb-6 text-xs font-bold uppercase tracking-[0.28em] text-[#78825B]"
      >
        Bewertungen
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, delay: 0.05 }}
        className="font-display mb-14 max-w-2xl text-4xl font-light leading-tight tracking-tight text-[#1A1C19] sm:text-5xl"
      >
        Was unsere Gäste <span className="italic text-[#4B7F94]">sagen</span>
      </motion.h2>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="flex flex-col justify-between rounded-2xl border border-[#E2E0D8] bg-[#1A1C19] p-8 text-[#F9F8F6] md:row-span-1"
          data-testid="rating-overview-card"
        >
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#F9F8F6]/60">Gesamtbewertung</p>
            <p className="font-display mt-4 text-6xl font-light tracking-tight">
              4,5<span className="text-2xl text-[#F9F8F6]/50">/5</span>
            </p>
            <Stars className="mt-4" />
          </div>
          <div className="mt-8 space-y-3 border-t border-white/10 pt-6 text-sm text-[#F9F8F6]/75">
            <p className="flex items-baseline justify-between">
              <span>Google</span>
              <span className="font-display text-lg text-[#F9F8F6]">4,5/5 · 1,2K Rezensionen</span>
            </p>
            <p className="flex items-baseline justify-between">
              <span>Gelbe Seiten</span>
              <span className="font-display text-lg text-[#F9F8F6]">3,8/5</span>
            </p>
          </div>
        </motion.div>

        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.author}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i + 1) * 0.08 }}
            className="flex flex-col justify-between rounded-2xl border border-[#E2E0D8] bg-white/70 p-8 backdrop-blur-sm transition-transform duration-300 hover:-translate-y-1"
            data-testid={`review-card-${i + 1}`}
          >
            <div>
              <div className="flex items-center justify-between">
                <Stars />
                <Quote size={18} strokeWidth={1.5} className="text-[#78825B]/50" />
              </div>
              <blockquote className="mt-5 text-base leading-relaxed text-[#1A1C19]/90">
                „{r.text}"
              </blockquote>
            </div>
            <figcaption className="mt-6 flex items-center justify-between border-t border-[#E2E0D8] pt-5">
              <div>
                <p className="text-sm font-semibold text-[#1A1C19]">{r.author}</p>
                <p className="text-xs text-[#4A4D46]">{r.time}</p>
              </div>
              <span className="rounded-full bg-[#4B7F94]/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.15em] text-[#4B7F94]">
                {r.source}
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
